import {
  FormLabel as MuiFormLabel,
  type FormLabelProps as MuiFormLabelProps,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup,
  type RadioGroupProps as MuiRadioGroupProps,
  type RadioProps as MuiRadioProps,
} from "@mui/material";

export type RadioProps = MuiRadioProps;
export type RadioGroupProps = MuiRadioGroupProps;
export type FormLabelProps = MuiFormLabelProps;

export const Radio = MuiRadio;
export const RadioGroup = MuiRadioGroup;
export const FormLabel = MuiFormLabel;
